<div class="sidebar">

  <a class="logo">
    <img src="assets/images/logo.png" alt="logo" i18n-alt="@@logoAlt" />
  </a>

  <a *ngIf="canViewHero" routerLink="/events" [ngClass]="{'active': isActive('/events')}" class="icon">
    <i [ngClass]="{
      'ri-earth-fill': isActive('/events'),
      'ri-earth-line': !isActive('/events')
    }"></i>
  </a>

  <!-- Show USERS link only if user has permission -->
  <a *ngIf="canViewUsers" routerLink="/user-management" [ngClass]="{'active': isActive('/user-management')}"
    class="icon">
    <i [ngClass]="{
      'ri-group-fill': isActive('/user-management'),
      'ri-group-line': !isActive('/user-management')
    }"></i>
  </a>

  <!-- Show ORGANIZATIONS link only if user has permission -->
  <a *ngIf="canViewOrganizations" routerLink="/organizations" [ngClass]="{'active': isActive('/organizations')}"
    class="icon">
    <i [ngClass]="{
      'ri-government-fill': isActive('/organizations'),
      'ri-government-line': !isActive('/organizations')
    }"></i>
  </a>

</div>